import React, { useState } from 'react';
import {
  View,
  Text,
  TextInput,
  TouchableOpacity,
  StyleSheet,
  ActivityIndicator,
  Alert,
  KeyboardAvoidingView,
  Platform,
  ScrollView,
} from 'react-native';
import { useAuth } from '../contexts/AuthContext';

const RegisterScreen = ({ navigation }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [familyName, setFamilyName] = useState('');
  const [invitationCode, setInvitationCode] = useState('');
  const [loading, setLoading] = useState(false);
  const { signUp } = useAuth();

  const handleRegister = async () => {
    if (!email || !password || !firstName || !lastName || !familyName || !invitationCode) {
      if (Platform.OS === 'web') {
        window.alert('Bitte alle Felder ausfüllen');
      } else {
        Alert.alert('Fehler', 'Bitte alle Felder ausfüllen');
      }
      return;
    }

    if (password !== confirmPassword) {
      if (Platform.OS === 'web') {
        window.alert('Passwörter stimmen nicht überein');
      } else {
        Alert.alert('Fehler', 'Passwörter stimmen nicht überein');
      }
      return;
    }

    if (password.length < 6) {
      if (Platform.OS === 'web') {
        window.alert('Passwort muss mindestens 6 Zeichen lang sein');
      } else {
        Alert.alert('Fehler', 'Passwort muss mindestens 6 Zeichen lang sein');
      }
      return;
    }

    setLoading(true);
    const result = await signUp(email, password, firstName, lastName, familyName, invitationCode);
    setLoading(false);

    if (!result.success) {
      if (Platform.OS === 'web') {
        window.alert(`Registrierung fehlgeschlagen: ${result.error}`);
      } else {
        Alert.alert('Registrierung fehlgeschlagen', result.error);
      }
    }
  };

  return (
    <View style={styles.container}>
      <ScrollView contentContainerStyle={styles.scrollContent}>
        <Text style={styles.title}>Konto erstellen</Text>
        <Text style={styles.subtitle}>Erstelle deine Familie</Text>

        {Platform.OS === 'web' ? (
          <>
            <input
              style={styles.webInput}
              placeholder="Vorname"
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
              type="text"
              autoComplete="given-name"
              autoFocus={false}
              readOnly={false}
              tabIndex={1}
            />

            <input
              style={styles.webInput}
              placeholder="Nachname"
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
              type="text"
              autoComplete="family-name"
              autoFocus={false}
              readOnly={false}
              tabIndex={2}
            />

            <input
              style={styles.webInput}
              placeholder="Familienname (z.B. Familie Müller)"
              value={familyName}
              onChange={(e) => setFamilyName(e.target.value)}
              type="text"
              autoComplete="organization"
              autoFocus={false}
              readOnly={false}
              tabIndex={3}
            />

            <input
              style={styles.webInput}
              placeholder="Einladungscode"
              value={invitationCode}
              onChange={(e) => setInvitationCode(e.target.value)}
              type="text"
              autoComplete="off"
              autoFocus={false}
              readOnly={false}
              tabIndex={4}
            />

            <input
              style={styles.webInput}
              placeholder="E-Mail"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              type="email"
              autoComplete="email"
              autoFocus={false}
              readOnly={false}
              tabIndex={5}
            />

            <input
              style={styles.webInput}
              placeholder="Passwort (min. 6 Zeichen)"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              type="password"
              autoComplete="new-password"
              autoFocus={false}
              readOnly={false}
              tabIndex={6}
            />

            <input
              style={styles.webInput}
              placeholder="Passwort bestätigen"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              type="password"
              autoComplete="new-password"
              autoFocus={false}
              readOnly={false}
              tabIndex={7}
            />
          </>
        ) : (
          <>
            <TextInput
              style={styles.input}
              placeholder="Vorname"
              value={firstName}
              onChangeText={setFirstName}
              autoCapitalize="words"
              autoComplete="given-name"
              inputMode="text"
            />

            <TextInput
              style={styles.input}
              placeholder="Nachname"
              value={lastName}
              onChangeText={setLastName}
              autoCapitalize="words"
              autoComplete="family-name"
              inputMode="text"
            />

            <TextInput
              style={styles.input}
              placeholder="Familienname (z.B. Familie Müller)"
              value={familyName}
              onChangeText={setFamilyName}
              autoCapitalize="words"
              autoComplete="organization"
              inputMode="text"
            />

            <TextInput
              style={styles.input}
              placeholder="Einladungscode"
              value={invitationCode}
              onChangeText={setInvitationCode}
              autoCapitalize="none"
              autoCorrect={false}
              inputMode="text"
            />

            <TextInput
              style={styles.input}
              placeholder="E-Mail"
              value={email}
              onChangeText={setEmail}
              autoCapitalize="none"
              keyboardType="email-address"
              autoCorrect={false}
              autoComplete="email"
              inputMode="email"
            />

            <TextInput
              style={styles.input}
              placeholder="Passwort (min. 6 Zeichen)"
              value={password}
              onChangeText={setPassword}
              secureTextEntry
              autoCapitalize="none"
              autoComplete="new-password"
              inputMode="text"
            />

            <TextInput
              style={styles.input}
              placeholder="Passwort bestätigen"
              value={confirmPassword}
              onChangeText={setConfirmPassword}
              secureTextEntry
              autoCapitalize="none"
              autoComplete="new-password"
              inputMode="text"
            />
          </>
        )}

        <TouchableOpacity
          style={styles.button}
          onPress={handleRegister}
          disabled={loading}
        >
          {loading ? (
            <ActivityIndicator color="#fff" />
          ) : (
            <Text style={styles.buttonText}>Registrieren</Text>
          )}
        </TouchableOpacity>

        <TouchableOpacity
          style={styles.linkButton}
          onPress={() => navigation.goBack()}
        >
          <Text style={styles.linkText}>
            Bereits ein Konto? Jetzt anmelden
          </Text>
        </TouchableOpacity>
      </ScrollView>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#f5f5f5',
  },
  scrollContent: {
    flexGrow: 1,
    justifyContent: 'center',
    padding: 20,
  },
  title: {
    fontSize: 32,
    fontWeight: 'bold',
    color: '#2E7D32',
    marginBottom: 8,
    textAlign: 'center',
  },
  subtitle: {
    fontSize: 18,
    color: '#666',
    marginBottom: 40,
    textAlign: 'center',
  },
  input: {
    backgroundColor: '#fff',
    padding: 15,
    borderRadius: 8,
    marginBottom: 15,
    fontSize: 16,
    borderWidth: 1,
    borderColor: '#ddd',
  },
  webInput: {
    backgroundColor: '#fff',
    padding: 15,
    borderRadius: 8,
    marginBottom: 15,
    fontSize: 16,
    border: '1px solid #ddd',
    width: '100%',
    boxSizing: 'border-box',
    WebkitAppearance: 'none',
    WebkitTouchCallout: 'none',
    WebkitUserSelect: 'text',
    userSelect: 'text',
    outline: 'none',
    cursor: 'text',
    touchAction: 'manipulation',
    WebkitTapHighlightColor: 'transparent',
  },
  button: {
    backgroundColor: '#2E7D32',
    padding: 15,
    borderRadius: 8,
    alignItems: 'center',
    marginTop: 10,
  },
  buttonText: {
    color: '#fff',
    fontSize: 16,
    fontWeight: '600',
  },
  linkButton: {
    marginTop: 20,
    alignItems: 'center',
  },
  linkText: {
    color: '#2E7D32',
    fontSize: 14,
  },
});

export default RegisterScreen;

